import Vue from 'vue'
import vueRouter from 'vue-router';
import dataCharts from '../views/dataCharts';
Vue.use(vueRouter)
const routes = [
    {
        path: '/',
        name: 'dataCharts',
        component: dataCharts 
    }
]
const router = new vueRouter({
    routes
})
export default router